import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import * as Cruds from 'react/containers/cruds';

const CrudWrapper = ({
  store,
  entity,
  id,
  isGrid,
  isLookup
}) => {
  const Crud = Cruds[entity];
  return (
    <Provider store={store}>
      <Crud entity={entity} id={id} isGrid={isGrid} isLookup={isLookup} />
    </Provider>
  );
};

CrudWrapper.propTypes = {
  store: PropTypes.object.isRequired,
  entity: PropTypes.string.isRequired,
  id: PropTypes.string,
  isGrid: PropTypes.bool,
  isLookup: PropTypes.bool
};

CrudWrapper.defaultProps = {
  id: null,
  isGrid: false,
  isLookup: false
};

export default CrudWrapper;
